





























































// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue';
import Vue from 'vue';
import { IMall } from '@/Store/index.js';
import HorizontalSwiper from '@/components/HorizontalSwiper.vue';
import BasePage from '@/components/BasePage.vue';
import SearchField from '@/views/Search/SearchField.vue';

export default Vue.extend({
  name: 'home',
  data() {
    return {
      searchText: '',
      searchBoxProps: {
        hideNoData: true,
        allowClear: true,
        noFilter: true,
      },
      cardWidth: '120px',
    };
  },
  computed: {
    items(): IMall[] {
      return this.$store.state.nearbyMalls;
    },
  },
  created(): void {
    this.$store.dispatch('fetchNearbyMalls');
  },
  components: {
    // HelloWorld,
    HorizontalSwiper,
    BasePage,
    SearchField,
  },
});
